const reducer = async (action, data, state) => {

  switch (action) {
    case "GET_SCHEMA":
      //Disabled edit NUz in grid
      const gridSchema = state.gridSchema.map(column => {
        if (column.field === "NUz") {
          column.editable = false
        }
        return column
      });
      return { ...state, gridSchema };
    case "CHANGE":
      if (data.field === "NUz") {
        //Required password after change NUz
        const newSchema = data.obj.self.state.detailSchema.map(x => x.field === "Heslo" ? { ...x, required: true } : x)
        return { ...state, detailSchema: newSchema };
      }
      return state

    case "UPDATE":
    case "SELECT":
      //Remove required password
      const newSchema = data.obj.self.state.detailSchema.map(x => x.field === "Heslo" ? { ...x, required: false } : x)
      return { ...state, detailSchema: newSchema };
    default:
      return state;
  }
}

export default reducer;